module.exports = __webpack_public_path__ + "static/media/bgpauto.07829242.jpg";